import { createAsyncThunk } from '@reduxjs/toolkit';

import { resetMilestonesUpdated } from './milestones/milestones.slice';
import api, { ApplicationStatus, ApplicationPayload, AxiosError } from 'api';

export const loadApp = createAsyncThunk(
    'api/application/{application_id}',
    async (appId: string, { dispatch }) => {
        const resp = await api.application.get(appId);
        if (resp.data.status === ApplicationStatus.COUNTEROFFER_CANDIDATE) {
            dispatch(resetMilestonesUpdated(true));
        } else {
            dispatch(resetMilestonesUpdated(false));
        }
        return resp;
    }
);

export const updateApp = createAsyncThunk(
    'api/application/{application_id}(PUT)',
    async (data: ApplicationPayload & { appId: string }, { dispatch }) => {
        const appIdStore = { id: data.appId };
        const tmp: { appId?: string } & ApplicationPayload = { ...data };
        delete tmp.appId;
        const payload: ApplicationPayload = { ...tmp };
        const updateResp = await api.application.put(appIdStore.id, payload);
        dispatch(loadApp(appIdStore.id));
        return updateResp;
    }
);

export const createApp = createAsyncThunk(
    'api/application/{application_id}(POST)',
    async (payload: ApplicationPayload, { rejectWithValue }) => {
        try {
            return await api.application.post(payload);
        } catch (e) {
            return rejectWithValue((e as AxiosError).response?.data);
        }
    }
);
